import { Component, Input, OnInit } from '@angular/core';
import { SendingChannelType } from '../../models/SendingChannelType';

@Component({
  selector: 'app-sending-channel-icon',
  templateUrl: './sending-channel-icon.component.html',
  styleUrls: ['./sending-channel-icon.component.scss']
})
export class SendingChannelIconComponent implements OnInit {

  constructor() { }

  @Input() sendingChannel:number;
  @Input() size = 32;
  sendingChannelSms = SendingChannelType.Sms;
  sendingChannelPortal = SendingChannelType.Portal;
  sendingChannelEmail = SendingChannelType.Email;
  ngOnInit(): void {
  }

}
